import request from './axios'

//考核任务列表
export const GetTaskList = (params) => {
    return request({
      url: "/checkTask/list",
      method: "post",
      data: params,
    });
  };
//新增考核任务
export const AddTaskUpdate = (params) => {
    return request({
      url: "/checkTask/addOrUpdate",
      method: "post",
      data: params,
    });
  };
  
//考核任务删除
export const TaskDelete = (id) => {
    return request({  
      url: `/checkTask/delete?id=${id}`,
      method: "delete",
    });
  };
// 考核项列表
export const  CheckTaskList= (checkTaskId ) => {
    return request({
      url: `/checkTask/checkItem/list?checkTaskId=${checkTaskId }`,
      method: "post",
    });
  };

//考核项新增-编辑
export const addOrUpdate= (params) => {
  return request({
      url: `/checkTask/checkItem/addOrUpdate`,
      method: "post",
      data:params,
    });
}
//考核项删除
export const checkItemDeletet= (id) => {
  return request({
      url: `/checkTask/checkItem/delete?checkItemId=${id}`,
      method: "delete",
    });
}
//考核任务列表-状态修改
export const updateStatus= (id,status) => {
  return request({
      url: `/checkTask/updateStatus?id=${id}&status=${status}`,
      method: "POST",
    });
}



//考核统计列表
export const CheckTakTongjiList = (params) => {
    return request({
      url: "/checkTask/checkStatistics",
      method: "post",
      data: params,
    });
  };
//统计导出
export const exportTongjiInfo= (params) => {
    return request({
        url: `/checkTask/checkStatistics/export`,
        method: "post",
        responseType: 'blob',
        data:params,
      });
}
  
//考核记录列表
export const recordTaskList= (params) => {
    return request({
        url: `/checkTask/checkRecord/list`,
        method: "post",
        data:params,
      });
}
// 考核记录删除

export const getDeletCheckTask= (id) => {
  return request({
      url: `/checkTask/CheckRecord?checkRecordId=${id}`,
      method: "delete",
    });
}

//考核记录导出
export const RecordExportTask= (params) => {
  return request({
      url: `/checkTask/checkRecord/export`,
      method: "post",
      responseType: 'blob',
      data:params,
    });
}

//学生列表/老师列表-根据姓名模糊查询
export const userList = (name,id) => {
   return request({
   url: `/checkTask/userList?name=${name}&schoolId=${id}`,
   method: "post",
   })
  }

// 年度综合排名
export const annualOverallRanking = (data) => {
   return request({
    url: `/checkTask/annualOverallRanking`,
    method: "post",
    data
   })
   }
  // 得分
  export const monthStatistics = (data) => {
   return request({
    url: `/checkTask/monthStatistics`,
    method: "post",
    data
   })
   }
  //   班级统计报表
  export const GetClassFormlist = (data) => {
    return request({
     url: `/checkTask/checkStatementStatistics/class`,
     method: "post",
     data
    })
    }
    
 //学生报表
export const  GetStudentFormlist= (data) => {
  return request({
   url: `/checkTask/checkStatementStatistics/student`,
   method: "post",
   data
  })
  }
  
//班级报表导出
export const checkTaskclassExport = (data) => {
  return request({
   url: `/checkTask/checkStatementStatistics/classExport`,
   method: "post",
   data,
   responseType: 'blob',

  })
  }
  //学生报表导出
  export const checkTaskStudentExport = (data) => {
    return request({
     url: `/checkTask/checkStatementStatistics/studentExport`,
     method: "post",
     data,
     responseType: 'blob',
  
    })
    }